import React from 'react';
import PropTypes from 'prop-types';
import './index.css'; // We'll update this CSS file

const Loader = ({ isLoading, color, size, overlayColor, message, spinnerType }) => {
  if (!isLoading) return null;

  const renderSpinner = () => {
    switch (spinnerType) {
      case 'dots':
        return (
          <div className="dots-spinner">
            {[...Array(3)].map((_, i) => (
              <div 
                key={i} 
                className="dot" 
                style={{ backgroundColor: color }}
              />
            ))}
          </div>
        );
      case 'bar':
        return (
          <div className="bar-spinner" style={{ backgroundColor: color }} />
        );
      case 'circle':
      default:
        return (
          <div 
            className="circle-spinner" 
            style={{ 
              borderColor: `${color} transparent transparent transparent`,
              width: size,
              height: size
            }}
          />
        );
    }
  };

  return (
    <div className="loader-overlay" style={{ backgroundColor: overlayColor }}>
      <div className="loader-content">
        {renderSpinner()}
        {message && <p className="loader-message">{message}</p>}
      </div>
    </div>
  );
};

Loader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  overlayColor: PropTypes.string,
  message: PropTypes.string,
  spinnerType: PropTypes.oneOf(['circle', 'dots', 'bar'])
};

Loader.defaultProps = {
  color: '#3498db',
  size: '50px',
  overlayColor: 'rgba(255, 255, 255, 0.7)',
  message: 'Loading...',
  spinnerType: 'circle'
};

export default Loader;